<div
  *ngIf="visibleActions$ | async as visibleActions"
  class="actions"
  [style.flex-wrap]="(maxButtons$ | async) < 2 ? 'wrap' : 'nowrap'"
  [style.justify-content]="alignActions">
  <app-custom-button
    *ngFor="let action of visibleActions.slice(0, maxButtons$ | async); let i = index"
    [show]="true"
    [type]="mapCustomButtonType(action.actionType)"
    [disable]="disableButton(action)"
    [infoInButton]="action.infoInButton"
    [tooltip]="action.tooltip"
    (onClick)="onButtonClicked(action)"
    [title]="action.actionName"></app-custom-button>

  <button
    mat-flat-button
    color="primary"
    appMeasure
    (width)="moreButtonWidth = $event"
    [matMenuTriggerFor]="overflowMenu"
    *ngIf="(visibleActions$ | async).length > (maxButtons$ | async)">
    <mat-icon>more_vert</mat-icon>
  </button>
</div>

<mat-menu #overflowMenu="matMenu" *ngIf="visibleActions$ | async as visibleActions">
  <button
    mat-menu-item
    *ngFor="let btn of visibleActions.slice(maxButtons$ | async)"
    (click)="onButtonClicked(btn)">
    {{ btn.actionName }}
  </button>
</mat-menu>

<div>
  <!-- this is our helper to calculate the offsetWidth of the buttons -->
  <div
    *ngIf="visibleActions$ | async as visibleActions"
    style="visibility: hidden; position: absolute; left: -10000px">
    <app-custom-button
      appMeasure
      (width)="buttonWidths[i] = $event"
      *ngFor="let action of visibleActions; let i = index"
      [show]="true"
      [disable]="disableButton(action)"
      [infoInButton]="action.infoInButton"
      [tooltip]="action.tooltip"
      [title]="action.actionName"></app-custom-button>
  </div>
</div>
